import React from 'react';

import { IRefetchContextProps } from './types';

export const RefetchContext = React.createContext<IRefetchContextProps>({
  /** Чтобы оставлять метод обязательным */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  addItem: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  removeItem: () => {},
});
